// extracted by mini-css-extract-plugin
export default {"root":"liB94oXH8wmhsFLttT6e","placeHolderShimmer":"T6aiQ7WYyNvCEBSqnyUj"};